module.exports = "/dist/635de59c4be86285b1f70068c95b9816.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-500italic.woff
// module id = 126
// module chunks = 0